import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { ActionListItem } from './ActionListItem';
import { Toggle } from '../Toggle';
import { useControlledValue } from '../../utils';
const ActionListToggleForward = forwardRef(function ActionListToggleForward(props, ref) {
    const { onFocus, ...rest } = props;
    return (React.createElement(Toggle, { ...rest, size: "small", role: "menuitemcheckbox", UNSAFE_elementType: "div", UNSAFE_omitInput: true, UNSAFE_labelRef: ref, UNSAFE_labelOnFocus: onFocus, UNSAFE_indicatorClassName: "mollie-ui-action-list-item-indicator" }));
});
export function ActionListToggle(props) {
    const { className, checked: userChecked, onChange, defaultChecked, ...rest } = props;
    const [checked, setChecked] = useControlledValue({
        value: userChecked,
        onChange,
        defaultValue: defaultChecked !== null && defaultChecked !== void 0 ? defaultChecked : false,
    });
    return (React.createElement(ActionListItem, { ...rest, elementType: ActionListToggleForward, className: clsx('mollie-ui-action-list-item--toggle', className), checked: checked, onClick: () => {
            setChecked((checked) => !checked);
        } }));
}
ActionListToggle.displayName = 'ActionList.Toggle';
//# sourceMappingURL=ActionListToggle.js.map